type User = {
    id: number,
    uid?: string,
    name?: string,
    phone?: string,
    document?: string,
    document_type?: number,
    address?: string,
    companyName?: string,
    email?: string,
    terms?: boolean,
    role_id?: number,
    url_avatar?: string,
    created_at?: string,
    updated_at?: string,
};

type UserRequest = {
    name: string;
    phone: string;
    document: string;
    documentType: number;
    address: string;
    companyName: string;
    email: string;
    terms: boolean;
    urlAvatar?: string;
    roleId?: number;
};

type UserShare = {
    companyName: string,
    uid: string,
    roleID: number,
    role: string,
}

type IdType = {
    id: number,
    type: string,
}

class UserFactory {
    public static create(
        id: number,
        uid: string,
        name: string,
        phone: string,
        document: string,
        document_type: number,
        address: string,
        companyName: string,
        email: string,
        terms: boolean,
        role_id: number,
        url_avatar: string,
        created_at: string,
        updated_at: string
    ): User {
        return {
            id,
            uid,
            name,
            phone,
            document,
            document_type,
            address,
            companyName,
            email,
            terms,
            role_id,
            url_avatar,
            created_at,
            updated_at,
        };
    }

    public static createRequest(data: Partial<UserRequest>): UserRequest {
        return {
            name: data.name || '',
            phone: data.phone || '',
            document: data.document || '',
            documentType: data.documentType || 0,
            address: data.address || '',
            companyName: data.companyName || '',
            email: data.email || '',
            terms: data.terms || false,
            urlAvatar: data.urlAvatar,
            roleId: data.roleId,
        };
    }

    public static createShare(
        companyName: string,
        uid: string,
        roleID: number,
        role: string
    ): UserShare {
        return {
            companyName,
            uid,
            roleID,
            role,
        };
    }

    public static createIdType(id: number, type: string): IdType {
        return {
            id,
            type,
        };
    }
}

export { User, UserRequest, UserShare, UserFactory, IdType };
